import React, { FC } from 'react';
import './InlineButtonContainer.css';

export interface ButtonContainerProps extends React.PropsWithChildren {
  buttonContainerId?: string;
  dataTestId?: string;
}

export const InlineButtonContainer: FC<ButtonContainerProps> = ({ children, dataTestId }) => {
  return (
    <div className="btnContainerInline" data-testid={dataTestId ?? ''}>
      {children}
    </div>
  );
};
